import React, { FunctionComponent } from 'react';
import { Company, DataCategory, DataValueCompanyPageStories } from '../../../types/companyDetail';
import { CompanyDetailStoriesChild } from '../../molecules/companyDetailStoriesChild';

type Props = {
  company: Company;
  postIds: number[];
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageStories;
};

export const Presentation: FunctionComponent<Props> = ({
  company,
  postIds,
  dataCategory,
  dataValue,
}) => {
  if (!postIds || postIds.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider" id="stories">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">ストーリー</h2>
        {company && (
          <a
            href={`/companies/${company.id}/stories`}
            className="company__page__recruitments__header--link gtm-button-view-count"
            data-event-name='button on screen'
            data-click="click"
            data-category={dataCategory}
            data-value={dataValue.moreSelfStories}
          >
            すべてのストーリーを見る
          </a>
        )}
      </div>

      <div className="company__page__recruitments__wrapper slides">
        {postIds.map((id) => (
          <CompanyDetailStoriesChild
            key={id}
            id={id}
            companyId={company.id}
            dataCategory={dataCategory}
            dataValue={dataValue}
          />
        ))}
      </div>
    </section>
  );
};
